import { Icon } from '@iconify/react';

function App(props) {

  var icon = props.icon;
  var onClick = props.onClick;
  var title = props.title;
  var className = props.className;
  var isBrightWhenLit = props.isBrightWhenLit;
  var height = props.height;
  var style = props.style;


  var className1 = 'normalIcon';
  if (isBrightWhenLit){
    className1 = 'normalIconBright'
  }
  if (className){
    className1 = className;
  }

  var heightIn = '25px';
  if (height){
    heightIn = height;
  }

  var s = {};
  if (style){
    s = style;
  }
  
  var inside = <div className={className1}><Icon height={heightIn} icon={icon} onClick={onClick} style={{cursor:'pointer'}}/></div>
//
  if (title){
    return <i className='qtip tip-bottom' data-tip={title} style={s}>{inside}</i>
  }else{
    return <div style={s}>{inside}</div>
  }

}

export default App;
